import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roleTranslate',
})
export class RoleTranslatePipe implements PipeTransform {
  main_permission_keys = [
    'ALLOW_EDIT_HOSPITAL_NON_CONTRACT',
    'READ',
    'CREATE',
    'WRITE',
    'REGISTER',
    'EDIT',
    'DELETE',
    'REMOVE',
    'SUBMIT',
    'VERIFY',
    'APPROVE',
    'APPROVAL',
    'ACCEPT',
    'RETURN',
    'REJECT',
    'DISABLE',
    'TOPUP',
    'ALLOCATE',
    'WORK_HISTORY',
  ];

  exceptions = [
    // PERMISSION.ALLOW_MERGE_SEPARATE_WI_VICTIM,

    'ALLOW_DOWNLOAD_WORK_ACTIVITY_REQ',
    'CLAIM_REQUEST_NSSF_READ_ALL',
    'READ_REPORT_PATIENT_FORM_NSSF',
    'READ_REPORT_PATIENT_FORM',
  ];

  transform(value: string): string {
    let result = this.main_permission_keys.find((key: string) =>
      value.includes(key),
    );
    let exception = this.exceptions.find((key: string) => value.includes(key));

    return `pms_child_code.${exception || result || value}`;
  }
}
